<script lang="ts">
    import { fade } from "svelte/transition";
    import { afterNavigate } from '$app/navigation';

    export let key: any;
    afterNavigate(() => {
      const el = document.getElementById("nucampmain")
      if (el) el.scrollTo({top: 0, left: 0, behavior: "smooth"});
    });
</script>

{#key key}
  <div transition:fade={{ duration: 250 }}>
    <slot/>
  </div>
{/key}